<ng-container *mobxAutorun>
  <app-ref-list [page]="query.page"
                [hide]="store.account.ignoreNotifications"
                [showPrev]="false"
                [showPageLast]="false"></app-ref-list>
</ng-container>
